import { Check, RefreshCw } from "lucide-react";
import type { ReactNode } from "react";

export interface OnboardingDgiFeedItem {
  label: ReactNode;
  /** Relative time text, e.g. "hace 2s" or "ahora". */
  when: string;
  /** When true, the ico spins (use for in-progress items). */
  spinning?: boolean;
}

interface OnboardingDgiFeedProps {
  items: OnboardingDgiFeedItem[];
}

/**
 * Live activity ticker used in the brand column of Paso 02 (DGI lookup)
 * and any other "system is doing something for you" surface. Static rows
 * by default; a row can show a spinning refresh glyph to indicate work
 * in progress.
 */
export function OnboardingDgiFeed({
  items,
}: OnboardingDgiFeedProps): JSX.Element {
  return (
    <div className="fx-onb-dgi-feed">
      {items.map((item, i) => (
        <div className="fx-onb-dgi-feed-item" key={i}>
          <span className="ico">
            {item.spinning ? (
              <RefreshCw className="spin" aria-hidden />
            ) : (
              <Check aria-hidden />
            )}
          </span>
          <span>{item.label}</span>
          <span className="when">{item.when}</span>
        </div>
      ))}
    </div>
  );
}
